import {useListView} from '../../core/ListViewProvider'
import {LanguagesListToolbar} from './LanguageListToolbar'
import {LanguagesListGrouping} from './LanguagesListGrouping'
import {LanguagesListSearchComponent} from './LanguagesListSearchComponent'

const LanguagesListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <LanguagesListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <LanguagesListGrouping /> : <LanguagesListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {LanguagesListHeader}
